import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
const initialState = {
  accessToken: localStorage.getItem('accessToken') ? localStorage.getItem('accessToken') : null,
  refreshToken: localStorage.getItem('refreshToken') ? localStorage.getItem('refreshToken') : null,
  admin: {},
}

const slice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    setAdmin: (state, action) => {
      state.admin = action.payload
    },
    setAccessToken: (state, action) => {
      state.accessToken = action.payload
    },
    setRefreshToken: (state, action) => {
      state.refreshToken = action.payload
    },
    clearToken: (state) => {
      state.accessToken = null
      state.refreshToken = null
      state.admin = {}
      localStorage.clear()
    },
  },
})

export const {setAccessToken, setRefreshToken, clearToken, setAdmin} = slice.actions
export default slice.reducer
